import './clients-panel.scss'

import styled from '@emotion/styled'
import { useState } from 'react'

import { Icon, LinkIcon, Space, Typography } from '@/components/core-v2'

import { AddClient } from '../client-details/add-client'
import { AddDfm } from '../client-details/add-dfm'
import { ClientList } from '../client-list/client-list'
import { ClientsState, CurrentUserType } from '../clients/clients.state'
import { DfmsState } from '../clients/dfm.state'
import { useClientsLayout } from '../clients-layout-provider'
import Modal from './modal'

export type Props = {
  onAddClientComplete: () => void
  onClientSearch: (searchTerm: string) => void
  onSelectBusinessUnit?: (businessUnitId: string) => void
  onSelectClient: (clientId: string) => void
  state: ClientsState | DfmsState
  userType: CurrentUserType
}

const StyledInput = styled.input`
  width: 100%;
  padding: 12px;
  margin: 0;
  border: none;
  background: var(--White95);
  font-size: 15px;
  outline: none;
  font-weight: normal;
  color: var(--Graphite);
`

const StyledList = styled.div`
  border-top: solid 1px var(--White90);
  height: calc(100vh - 289px);
  overflow-y: auto;
`

export function ClientsPanel({
  onAddClientComplete,
  onClientSearch,
  onSelectBusinessUnit,
  onSelectClient,
  state,
  userType
}: Props) {
  const [isAdding, setIsAdding] = useState(false)

  const { isPortfolioManagerScreen } = useClientsLayout()

  const title = isPortfolioManagerScreen ? 'portfolio manager' : 'client'

  const count = isPortfolioManagerScreen
    ? (state as DfmsState).filteredDfms?.length ?? 0
    : (state as ClientsState).filteredClients?.length ?? 0

  return (
    <Space isflex flexDirection="column">
      <Space mt={6}>
        <StyledInput
          placeholder={`Search for a ${title} by name`}
          type="text"
          onChange={e => onClientSearch(e.target.value)}
        />
      </Space>
      <Space isflex fontSize="15px" justifyContent="space-between" py={6}>
        <Typography fontSize="15px" fontWeight="800" letterSpacing="0px" variant="b3">
          {count} found
        </Typography>
        {userType === 'admin' && (
          <LinkIcon
            disabled={false}
            icon={<Icon name="circleAdd" size="default" />}
            iconPosition="left"
            text={`Add new ${title === 'client' ? `${title} user` : title}`}
            onClick={() => setIsAdding(true)}
          />
        )}
      </Space>
      <StyledList>
        <ClientList
          state={state}
          onSelectBusinessUnit={onSelectBusinessUnit}
          onSelectClient={onSelectClient}
        />
      </StyledList>
      <Modal isOpen={isAdding}>
        {isPortfolioManagerScreen ? (
          <AddDfm
            onAddComplete={() => {
              setIsAdding(false)
              onAddClientComplete()
            }}
            onClose={() => setIsAdding(false)}
          />
        ) : (
          <AddClient
            clientState={state as ClientsState}
            onAddComplete={() => {
              setIsAdding(false)
              onAddClientComplete()
            }}
            onClose={() => setIsAdding(false)}
          />
        )}
      </Modal>
    </Space>
  )
}
